import { Color, Vector2 } from "three";
import { Maps, useMaterial, useMeshPhysicalMaterial } from "@utils/useMaterial";

/* Textures - Modify as needed */
const maps: Partial<Maps> = {
    roughnessMap: ["T_PowderCoat_R.png", {
        repeat: new Vector2(2, 2)
    }],
    normalMap: ["T_PowderCoat_N.png", {
        repeat: new Vector2(2, 2)
    }],
    aoMap: ["T_Coolant_AO.jpg", {
        channel: 1
    }]
};

/* Preload textures */
useMaterial.preload(maps);

export default function useMat() {
    /* Create Material - Modify as needed */
    return useMeshPhysicalMaterial(maps, {
        color: new Color("#0176EA"),
        metalness: 0,
        roughness: 1,
        normalScale: new Vector2(0.3, 0.3),
        envMapIntensity: 1,
    });
}